import { Crown } from "lucide-react";

// Platinum $MWP holders get a crowned frame around their portrait wherever it shows.
export const CrownFrame = ({ tier, children, className = "", small = false }) => {
  if (tier !== "platinum") return <div className={`relative ${className}`}>{children}</div>;
  return (
    <div data-testid="platinum-crown-frame" title="$MWP Platinum holder" className="relative shrink-0">
      <div className={`${className} ${small ? "p-[2px]" : "p-1"} bg-[conic-gradient(from_200deg,#f0fbff,#9fd8ee,#fff6c2,#d4af37,#f0fbff,#9fd8ee,#f0fbff)] shadow-[0_0_18px_rgba(165,243,252,.55)]`}>
        {children}
      </div>
      <span className={`absolute left-1/2 -translate-x-1/2 ${small ? "-top-2.5" : "-top-5"} z-10 drop-shadow-[0_2px_6px_rgba(0,0,0,.7)]`}>
        <Crown className={`${small ? "w-4 h-4" : "w-9 h-9"} text-[#f5d76e] fill-[#f5c518]/80`} strokeWidth={1.6} />
      </span>
    </div>
  );
};
